if (!customElements.get('sticky-mobile-atc')) {
  customElements.define(
    'sticky-mobile-atc',
    class StickyMobileAtc extends HTMLElement {
      connectedCallback() {
        if (this.parentElement !== document.body) {
          document.body.appendChild(this);
          return;
        }

        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.sectionId = this.dataset.sectionId;
        this.submitButton = document.getElementById(this.dataset.mainSubmitId);
        this.stickyButton = this.querySelector('.sticky-mobile-atc__button');
        this.priceNode = this.querySelector('.sticky-mobile-atc__price');
        this.moneyFormat = this.dataset.moneyFormat;
        this.breakpoint = window.matchMedia('(min-width: 990px)');

        if (!this.submitButton || !this.stickyButton) return;

        this.observeMainButton();
        this.updateAvailabilityFromMainButton();
        this.subscribeToVariantChanges();

        this.onResize = this.handleViewportChange.bind(this);
        this.breakpoint.addEventListener('change', this.onResize);
      }

      disconnectedCallback() {
        this.breakpoint?.removeEventListener('change', this.onResize);
        this.observer?.disconnect();
        this.unsubscribeVariant?.();
      }

      handleViewportChange() {
        if (this.breakpoint.matches) {
          this.classList.remove('is-visible');
          this.setAttribute('aria-hidden', 'true');
        }
      }

      observeMainButton() {
        this.observer = new IntersectionObserver(
          (entries) => {
            if (this.breakpoint.matches) return;

            const entry = entries[0];
            const shouldShow = !entry.isIntersecting;
            this.classList.toggle('is-visible', shouldShow);
            this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
          },
          { rootMargin: '0px 0px -20% 0px' }
        );

        this.observer.observe(this.submitButton);
      }

      updateAvailabilityFromMainButton() {
        const disabled = this.submitButton.hasAttribute('disabled');
        this.stickyButton.disabled = disabled;
        this.stickyButton.textContent = disabled ? window.variantStrings.soldOut : window.variantStrings.addToCart;
      }

      subscribeToVariantChanges() {
        if (typeof subscribe !== 'function' || !window.PUB_SUB_EVENTS?.variantChange) return;

        this.unsubscribeVariant = subscribe(window.PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (!data || data.sectionId !== this.sectionId) return;

          const variant = data.variant;
          if (!variant) return;

          if (this.priceNode && this.moneyFormat) {
            this.priceNode.textContent = Shopify.formatMoney(variant.price, this.moneyFormat);
          }

          const isAvailable = Boolean(variant.available);
          this.stickyButton.disabled = !isAvailable;
          this.stickyButton.textContent = isAvailable ? window.variantStrings.addToCart : window.variantStrings.soldOut;
        });
      }
    }
  );
}
